import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard } from '@okta/okta-angular';
import { AuthGuard } from './auth-guard.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./Login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./Login-auth/login-auth.module').then(m => m.LoginAuthModule),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'demo',
    loadChildren: () => import('./demo/demo.module').then(m => m.DemoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./Login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'Rates',
    loadChildren: () => import('./Rates/rates.module').then(m => m.RatesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'Users',
    loadChildren: () => import('./Users/users.module').then(m => m.UsersModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'Master',
    loadChildren: () =>
      import('./Masters/masters.module').then(m => m.MasterModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'History',
    loadChildren: () =>
      import('./history/history.module').then(m => m.HistoryModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
